<template>
	<card ref="card" title="" icon="">
		<form-field label="日程" sub="必須" :has-wrap="false">
			<div class="field">
				<p class="control is-expanded date-picker-wrap">
					<date-picker :dateProvided="date" :minDate="minDate" :maxDate="maxDate" @input="onDateInput"></date-picker>
				</p>
				<p slot="help" class="help is-danger" v-show="hasError('date')">{{ errors.date }}</p>
			</div>
		</form-field>

		<form-field label="開始" sub="必須" :has-wrap="false">
			<div class="field">
				<p class="control is-expanded date-picker-wrap">
					<b-timepicker v-model="scheduleStart" icon="clock" :increment-minutes="minutesStep"></b-timepicker>
				</p>
				<p slot="help" class="help is-danger" v-show="hasError('scheduleStart')">{{ errors.scheduleStart }}</p>
			</div>
		</form-field>

		<form-field label="終了" sub="必須" :has-wrap="false">
			<div class="field">
				<p class="control is-expanded date-picker-wrap">
					<b-timepicker v-model="scheduleEnd" icon="clock" :increment-minutes="minutesStep"></b-timepicker>
				</p>
				<p slot="help" class="help is-danger" v-show="hasError('scheduleEnd')">{{ errors.scheduleEnd }}</p>
			</div>
		</form-field>

		<form-field label="" sub=" " :has-wrap="false">
			<div class="field">
				<b-checkbox v-model="is_overnight">
					日付をまたぐ
				</b-checkbox>
			</div>
		</form-field>

		<form-field label="店舗" sub="必須" :has-wrap="false">
			<div class="field">
				<b-select class="" v-model="shopId">
					<option
						v-for="(shop, index) in shops"
						:value="shop.id"
						:key="index">
						{{ shop.name }}
					</option>
				</b-select>
			</div>
		</form-field>

		<form-field label="スタッフ" sub="必須" :has-wrap="false">
			<b-select v-model="staff_id">
				<option
					v-for="(staff, index) in staffs"
					:value="staff.id"
					:key="index">
					{{ staff.name }}
				</option>
			</b-select>
		</form-field>

		<form-field label="シフトメモ" sub="" :has-wrap="false">
			<div class="field">
				<p class="control is-expanded">
					<input class="input" :class="{'is-danger': hasError('memo')}" type="text" v-model="memo">
				</p>
				<p slot="help" class="help is-danger" v-show="hasError('memo')">{{ errors.memo }}</p>
			</div>
		</form-field>

		<form-field label="" sub=" " :has-wrap="false">
			<div class="field">
				<b-checkbox v-model="is_director">
					ディレクター
				</b-checkbox>
			</div>
		</form-field>

		<form-field :has-wrap="false">
			<div class="buttons">
				<b-button type="is-light" @click="onBackButtonClick">戻る</b-button>
				<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
			</div>
		</form-field>
	</card>
</template>

<script>
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import DatePicker from '@/components/DatePicker'
import moment from 'moment';

export default {
	name: "ScheduleModal",
	components: {
		Card,
		FormField,
		DatePicker,
	},
	props: {
		year: {
			type: String,
			default: '',
		},
		month: {
			type: String,
			default: '',
		},
		id: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isLoading: false,
			date: '',
			shopId: '',
			shops: [],
			scheduleStart: null,
			scheduleEnd: null,
			staff_id: '',
			memo: '',
			is_director: false,
			is_overnight: false,
			errors: {
				date: '',
				memo: '',
				scheduleStart: '',
				scheduleEnd: '',
			},
			staffs: null,
			minutesStep: 15,
		}
	},
	computed: {
		minDate: function() {
			return moment(this.createFirstDay()).format('YYYY-MM-DD');
		},
		maxDate: function() {
			return moment(this.createFirstDay()).endOf('month').format('YYYY-MM-DD');
		},
	},
	mounted() {
		this.getData();
	},
	methods: {
		createFirstDay: function() {
			return `${this.year}-${this.$utils.zeroPadding(this.month, 2)}-01`;
		},
		hasError: function(key) {
			return this.$utils.hasError(this.errors, key);
		},
		onDateInput: function(date) {
			this.date = date;
		},
		getData: async function() {
			let loading = this.$loading.open();
			let params = this.id ? '/' + this.id : '';
			let ep = 'works/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.staffs = res.data.staffs;
				this.date = res.data.date || this.createFirstDay();
				this.scheduleStart = res.data.schedule_start ? moment(res.data.date + ' ' + res.data.schedule_start).toDate() : moment(this.createFirstDay() + ' 10:00:00').toDate();
				this.scheduleEnd = res.data.schedule_end ? moment(res.data.date + ' ' + res.data.schedule_end).toDate() : moment(this.createFirstDay() + ' 19:00:00').toDate();
				this.is_director = res.data.is_director;
				this.is_overnight = res.data.is_overnight;
				this.memo = res.data.memo;
				this.staff_id = res.data.staff_id || res.data.staffs[0].id;
				this.shops = res.data.shops;
				this.shopId = res.data.shop_id || res.data.shops[0].id;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"date": this.date,
				"schedule_start": moment(this.scheduleStart).format('YYYY-MM-DD HH:mm'),
				"schedule_end": moment(this.scheduleEnd).format('YYYY-MM-DD HH:mm'),
				"shop_id": this.shopId,
				"memo": this.memo,
				"staff_id": this.staff_id,
				"is_director": this.is_director === true ? 1 : 0,
				"is_overnight": this.is_overnight === true ? 1 : 0,
			};
			this.$utils.log(data);

			let ep = 'works';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$emit('schedule-update');
				this.$parent.close();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
		onBackButtonClick: function() {
			this.$parent.close();
		},
	}
}
</script>

<style scoped>
.field:not(:last-child) {
	margin-bottom: 1.25rem;
}
.buttons {
	margin-top: 1.5rem;
}
.buttons button {
	width: 150px;
	margin-right: 30px !important;
}
</style>
